import { useBooleanFlagValue } from '@openfeature/react-sdk';

export const useRenewalUiReceivedInvoicesFlag = (): boolean =>
  useBooleanFlagValue('renewal-ui-received-invoices', false);
